import React, { useState } from "react";
import "./Admin.css";
import pokemons from "./pokemonData";

const AdminTeamcomp = () => {
  const [grid, setGrid] = useState(Array(6).fill(null)); // 1 Reihe mit 6 Spalten
  const [rating, setRating] = useState("S");
  const [selectedCellIndex, setSelectedCellIndex] = useState(null); // Speichert die angeklickte Zelle

  // Pokémon in die angeklickte Zelle setzen
  const handleSelectPokemon = (pokemon, stage) => {
    if (selectedCellIndex === null) return;
    const newGrid = [...grid];
    newGrid[selectedCellIndex] = { ...pokemon, stage };
    setGrid(newGrid);
    setSelectedCellIndex(null); // Modal schließen
  };

  // Zelle anklicken, öffnet Pokémon-Auswahl
  const handleCellClick = (index) => {
    setSelectedCellIndex(index);
  };

  // Teamcomp speichern
  const handleSaveTeamcomp = async () => {
    const pokemonImages = grid.filter(Boolean).map((p) => p.images[p.stage]); // Speichert die gewählte Entwicklungsstufe
    if (pokemonImages.length < 6) {
      alert("Bitte fülle das Grid mit 6 Pokémon!");
      return;
    }
    console.log("📌 Sende Teamcomp an Server:", JSON.stringify({ pokemon_list: pokemonImages, rating }));
    const response = await fetch("https://poke-meta.com/api/privatadmin/teamcomps", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pokemon_list: pokemonImages, rating }),
    });
    const data = await response.json();
    console.log("📌 Serverantwort:", data);

    if (response.ok) {
      alert("Teamcomp gespeichert!");
    } else {
      alert("Fehler beim Speichern!");
    }
  };

  return (
    <div className="admin-container">
      <h1 className="admin-title">Admin Teamcomp Erstellen</h1>

      {/* 1x6 Grid für Teamcomp */}
      <div className="grid-wrapper">
        <div className="grid-row">
          {grid.map((cell, index) => (
            <div key={index} className="grid-cell" onClick={() => handleCellClick(index)}>
              {cell ? (
                <img src={cell.images[cell.stage]} alt={cell.name} className="grid-pokemon" />
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Rating Auswahl */}
      <div className="rating-selection">
        <label>Bewertung:</label>
        <select value={rating} onChange={(e) => setRating(e.target.value)}>
          <option value="S">S (Sehr stark)</option>
          <option value="A">A (Gut)</option>
          <option value="B">B (Okay)</option>
          <option value="C">C (Schlecht)</option>
        </select>
      </div>

      {/* Modal mit Pokémon-Auswahl */}
      {selectedCellIndex !== null && (
        <div className="modal">
          <div className="modal-content">
            <h2>Pokémon auswählen</h2>
            <div className="pokemon-grid">
              {pokemons
                .flatMap((pokemon) =>
                  pokemon.images.map((image, stage) => ({
                    ...pokemon,
                    stage,
                    image,
                  }))
                )
                .reduce((rows, key, index) => {
                  if (index % 10 === 0) rows.push([]); // 10 Pokémon pro Reihe
                  rows[rows.length - 1].push(key);
                  return rows;
                }, [])
                .map((row, rowIndex) => (
                  <div key={rowIndex} className="pokemon-row">
                    {row.map((pokemon) => (
                      <div
                        key={`${pokemon.id}-${pokemon.stage}`}
                        className="pokemon-slot"
                        onClick={() => handleSelectPokemon(pokemon, pokemon.stage)}
                      >
                        <img src={pokemon.image} alt={`${pokemon.name} - Stufe ${pokemon.stage + 1}`} className="pokemon-item" />
                        <p>{`${pokemon.name} - Stufe ${pokemon.stage + 1}`}</p>
                      </div>
                    ))}
                  </div>
                ))}
            </div>
            <button onClick={() => setSelectedCellIndex(null)} className="close-button">Schließen</button>
          </div>
        </div>
      )}

      <button className="admin-button" onClick={handleSaveTeamcomp}> Speichern</button>
    </div>
  );
};

export default AdminTeamcomp;
